/**
 * Zuruflex speaks three languages. Kinyarwanda and French sit alongside English
 * as first-class options, not as an afterthought — the customer picks one in
 * WhatsApp and every surface honours it from then on.
 */
export const SUPPORTED_LOCALES = ['en', 'rw', 'fr'];
export const DEFAULT_LOCALE = 'en';
/** Namespaces map one-to-one onto `messages/<locale>/<namespace>.json`. */
export const NAMESPACES = ['common', 'errors', 'bot', 'web', 'admin', 'partner'];
export const LOCALES = {
    en: { nativeName: 'English', englishName: 'English', flag: '🇬🇧', intlTag: 'en-GH' },
    rw: { nativeName: 'Kinyarwanda', englishName: 'Kinyarwanda', flag: '🇷🇼', intlTag: 'rw-RW' },
    fr: { nativeName: 'Français', englishName: 'French', flag: '🇫🇷', intlTag: 'fr-FR' },
};
export function isLocale(value) {
    return typeof value === 'string' && SUPPORTED_LOCALES.includes(value);
}
/** Narrows anything to a supported locale, falling back to English. */
export function toLocale(value) {
    if (isLocale(value))
        return value;
    if (typeof value === 'string') {
        // `fr-CA`, `rw_RW` and `EN` all resolve to a base language we support.
        const base = value.toLowerCase().split(/[-_]/)[0];
        if (isLocale(base))
            return base;
    }
    return DEFAULT_LOCALE;
}
/** The tag to hand to `Intl` — not the same as our short locale code. */
export function intlTagFor(locale) {
    return LOCALES[locale].intlTag;
}
